
import { Component, OnInit } from '@angular/core';
import { PrimeNgModule } from '../primeng.module';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'alert-dialog',
    templateUrl: './alert.dialog.html',
    imports: [PrimeNgModule]
})
export class AlertDialogPrimeNg implements OnInit{
    visible: boolean = false;
    public body: string;
    public buttonText: string;

    constructor(public ref: DynamicDialogRef, 
        public config: DynamicDialogConfig){
    }

    ngOnInit(): void {
        this.visible = true;
        this.body = this.config.data.body;
        this.buttonText = this.config.data.buttonText;
    }

    close(event: any){
        this.ref.close(event);
    }
}